import React, { useState, useEffect } from 'react'
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";

const locations = [
    { value: '', label: 'All' },
    { value: '1487 5th Avenue', label: '1487 5th Avenue, Troy, NY' },
    { value: '172 River Street', label: '172 River Street, Troy, NY' },
    { value: '710 3rd Ave', label: '710 3rd Ave, Watervliet, NY' },
    { value: '706 3rd Avenue', label: '706 3rd Avenue, Watervliet, NY' },
    { value: '156 2nd Street', label: '156 2nd Street, Troy, NY' }
]

const beds = [
    { value: 0, label: 'Any' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' }
]

const baths = [
    { value: 0, label: 'Any' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' }
]

const availability = [
    { value: 0, label: 'Any' },
    { value: 1, label: 'Available' },
    { value: 2, label: 'Unavailable' },
]
const perking = [
    { value: 0, label: 'No Parking' },
    { value: 1, label: 'On-Street Parking' },
    { value: 2, label: 'Reserved Spot' },
]

export default function PropertySearch({ onSelectedPropertyTypeChanged, onSelectedLocationChanged, onSelectedBedroomsChanged, onSelectedBathroomsChanged, onSelectedAvailabilityChanged, onSelectedPerkingChanged }) {
    const location = useLocation();
    const navigate = useNavigate();

    const searchParams = new URLSearchParams(location.search);
    const propertySearchTypeURLParam = searchParams.get('propertyType');

    const [selectedPropertyType, setSelectedPropertyType] = useState(propertySearchTypeURLParam);
    const [selectedPerking, setSelectedPerking] = useState();
    const [selectedBathrooms, setSelectedBathrooms] = useState();
    const [selectedBedRooms, setSelectedBedrooms] = useState();
    const [selectedAvailability, setSelectedAvailability] = useState();
    const [selectedAddress, setSelectedAddress] = useState();

    const handleSelectedPropertyTypeChanged = (e) => {
        e.preventDefault();
        if (e.target.attributes['data-propertytype'] === 'undefined') return;

        // console.log(e.target.attributes);
        setSelectedPropertyType(e.target.attributes['data-propertytype'].value);
    }

    const handleSelectedLocationChanged = (selectedOption) =>
        setSelectedAddress(selectedOption.value);

    const handleSelectedBedroomsChanged = (selectedOption) =>
        setSelectedBedrooms(selectedOption.value);

    const handleSelectedBathroomsChanged = (selectedOption) =>
        setSelectedBathrooms(selectedOption.value);

    const handleSelectedAvailabilityChanged = (selectedOption) =>
        setSelectedAvailability(selectedOption.value);

    const handleSelectedPerkingChanged = (selectedOption) =>
        setSelectedPerking(selectedOption.value);

    const handleResetFilters = (e) => {
        e.preventDefault();
        setSelectedPropertyType(undefined);
        setSelectedAddress('');
        setSelectedBedrooms(0);
        setSelectedBathrooms(0);
        setSelectedAvailability(0);
        setSelectedPerking(0);
    }

    useEffect(() => {
        onSelectedPropertyTypeChanged(selectedPropertyType);
    }, [selectedPropertyType])

    useEffect(() => {
        onSelectedLocationChanged(selectedAddress);
    }, [selectedAddress])

    useEffect(() => {
        onSelectedBedroomsChanged(selectedBedRooms);
    }, [selectedBedRooms])

    useEffect(() => {
        onSelectedBathroomsChanged(selectedBathrooms);
    }, [selectedBathrooms])

    useEffect(() => {
        onSelectedAvailabilityChanged(selectedAvailability);
    }, [selectedAvailability])

    useEffect(() => {
        onSelectedPerkingChanged(selectedPerking);
    }, [selectedPerking])

    return (
        <div className="features-absolute">
            <div className="card search-border-1 bg-white mt-5 property-search">
                <form className="text-start">
                    <div className="registration-form text-dark text-start">
                        <div className="row px-3 py-2 align-items-center">
                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                <div className="mb-md-0 mb-1 tab_item w-100">
                                    <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "F" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="F">FURNISHED</a>
                                </div>
                            </div>
                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                  <div className="mb-md-0 mb-1 tab_item w-100">
                                    <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "U" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="U">UNFURNISHED</a>
                                </div>
                            </div>
                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                  <div className="mb-md-0 mb-1 tab_item w-100">
                                    <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "SF" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="SF">SEMI FURNISHED</a>
                                </div>
                            </div>
                            {/*<div className="col-lg-2 col-md-3 col-12 center-box">*/}
                            {/*    <div className="mb-lg-0 mb-1">*/}
                            {/*        <a className={typeof selectedPropertyType !== 'undefined' && selectedPropertyType === "SF" ? 'registration-form selected-search-key' : 'registration-form'} href="/" onClick={handleSelectedPropertyTypeChanged} data-propertytype="SF">SEMI-FURNISHED</a>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                <div className="mb-md-0 mb-1 w-100">
                                    <Select
                                        classNames={typeof selectedAddress !== undefined && selectedAddress?.length > 0 ? 'selected-search-key' : ''}
                                        placeholder="LOCATION"
                                        value={locations.find(option => option.value === selectedAddress)}
                                        onChange={handleSelectedLocationChanged} options={locations}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff',
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: '#f97316'
                                                })
                                            })
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                <div className="mb-md-0 mb-1 w-100">
                                    <Select
                                        id="bedrooms"
                                        className={typeof selectedBedRooms !== 'undefined' && selectedBedRooms !== 0 ? 'selected-search-key' : ''}
                                        placeholder="BEDROOMS"
                                        value={beds.find(option => option.value === selectedBedRooms)}
                                        onChange={handleSelectedBedroomsChanged}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                        options={beds} />
                                </div>
                            </div>

                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                <div className="w-100">
                                    <Select
                                        id="bathrooms"
                                        className={typeof selectedBathrooms !== 'undefined' && selectedBathrooms !== 0 ? 'selected-search-key' : ''}
                                        placeholder="BATHROOMS"
                                        value={baths.find(option => option.value === selectedBathrooms)}
                                        onChange={handleSelectedBathroomsChanged} options={baths}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                <div className="w-100">
                                    <Select
                                        id="availability"
                                        className={typeof selectedAvailability !== 'undefined' && selectedAvailability !== 0 ? 'selected-search-key' : ''}
                                        placeholder="AVAILABILITY"
                                        value={availability.find(option => option.value === selectedAvailability)}
                                        onChange={handleSelectedAvailabilityChanged} options={availability}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-6 center-box">
                                <div className="w-100">
                                    <Select
                                        id="perking"
                                        className={typeof selectedPerking !== 'undefined' && selectedPerking !== 0 ? 'selected-search-key' : ''}
                                        placeholder="PARKING"
                                        value={perking.find(option => option.value === selectedPerking)}
                                        onChange={handleSelectedPerkingChanged} options={perking}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                backgroundColor: '#ffffff',
                                                borderColor: '#ffffff'
                                            })
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="col-xl col-lg-2 col-md-3 col-sm-4 col-12 center-box mt-sm-0 mt-3">
                                <button
                                    onClick={handleResetFilters}
                                    className="btn filter_btn w-100"
                                >
                                    Reset Filters
                                </button>
                            </div>

                        </div>
                    </div>
                </form>
            </div>

        </div>
    )
}